import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";

const staffRows = [
  {
    name: "Ava Carter",
    organisation: "Northgate College",
    orgRole: "Teacher",
    groupRole: "Group Collaborator",
    status: "Active",
  },
  {
    name: "Harvey James",
    organisation: "Riverside School",
    orgRole: "School Admin",
    groupRole: "Group Admin",
    status: "Active",
  },
];

export default function OrganisationGroupsStaff() {
  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <h2>All Staff</h2>
        </div>
        <Row>
          <Col lg={4}>
            <div className="organisation-search-shell">
              <input type="text" placeholder="Search" />
            </div>
          </Col>
          <Col lg={3}>
            <div className="custom-select-wrapper">
              <Form.Select className="cmn-select">
                <option>All Member Organisations</option>
              </Form.Select>
            </div>
          </Col>
          <Col lg={5} className="create-new-btn d-flex justify-content-end">
            <button className="cmn-pink">Edit Permissions</button>
          </Col>
        </Row>
        <section className="organisation-groups-table-shell organisation-groups-table-shell-space">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Member Organisation</th>
                <th>Role in Organisation</th>
                <th>Role in Group</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {staffRows.map((row) => (
                <tr key={row.name}>
                  <td>{row.name}</td>
                  <td>{row.organisation}</td>
                  <td>{row.orgRole}</td>
                  <td>{row.groupRole}</td>
                  <td>{row.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </Container>
    </OrganisationLayout>
  );
}
